var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClockForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50065 2.66927C4.55513 2.66927 2.16732 5.05709 2.16732 8.0026C2.16732 10.9481 4.55513 13.3359 7.50065 13.3359C9.4739 13.3359 11.1977 12.2647 12.1209 10.6688C12.3053 10.3501 12.7131 10.2412 13.0318 10.4255C13.3505 10.6099 13.4594 11.0177 13.275 11.3364C12.1233 13.3274 9.9691 14.6693 7.50065 14.6693C3.81875 14.6693 0.833984 11.6845 0.833984 8.0026C0.833984 4.32071 3.81875 1.33594 7.50065 1.33594C10.8915 1.33594 13.691 3.86742 14.1125 7.14356L14.3833 6.87276C14.6436 6.61241 15.0657 6.61241 15.3261 6.87276C15.5864 7.13311 15.5864 7.55522 15.3261 7.81557L13.8261 9.31557C13.5657 9.57592 13.1436 9.57592 12.8833 9.31557L11.3833 7.81557C11.1229 7.55522 11.1229 7.13311 11.3833 6.87276C11.6436 6.61241 12.0657 6.61241 12.3261 6.87276L12.7932 7.33988C12.4669 4.7071 10.2218 2.66927 7.50065 2.66927ZM7.50065 4.94985C7.86884 4.94985 8.16732 5.24833 8.16732 5.61652V8.2721L9.96147 8.87015C10.3108 8.98658 10.4995 9.36413 10.3831 9.71342C10.2667 10.0627 9.88913 10.2515 9.53983 10.1351L7.28983 9.38506C7.0176 9.29432 6.83398 9.03956 6.83398 8.7526V5.61652C6.83398 5.24833 7.13246 4.94985 7.50065 4.94985Z",
    fill: "#4A5467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockForward);
export default __webpack_public_path__ + "static/media/ic-clock-forward.d38b7d757bba8d91abd4261448fe2ee0.svg";
export { ForwardRef as ReactComponent };